<template>
  <div class="card artist" v-if="this.chapter.artist">
    <div class="card-image">
      <img alt="" :src="logotype" class="image" />
    </div>
    <div class="card-image hover" v-if="this.chapter.thumbnail">
      <img alt="" :src="thumbnail" class="image" />
    </div>
    <div class="card-content">
      <p>{{ this.chapter.author }} on <strong><em>{{ this.chapter.title }}</em> ({{ this.chapter.year }})</strong></p>
    </div>
  </div>
  <div class="card text" v-else>
    <div class="card-content">
      <p class="title">{{ this.chapter.title }}</p>
      <p class="subtitle">{{ this.chapter.author }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tocItem',
  props: ['chapter'],
  computed: {
    logotype () {
      return require(`@/assets/images/${this.chapter.shortname}.svg`)
    },
    thumbnail () {
      return require(`@/assets/images/${this.chapter.thumbnail}`)
    }
  }
}
</script>

<style scoped>
.card {
  height: 100%;
}
.card.text {
  background-color: transparent;
  box-shadow: inherit;
}
.card img {
  max-height: 100%;
  width: 100%;
}
.card-image.hover {
  display: none;
  position: absolute;
  top: 0;
}
.card:hover .card-image.hover {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/TocItem.vue?559f36cb